module.exports = __webpack_public_path__ + "img/homezhuce.55b5f6dd.png";